module.exports = __webpack_public_path__ + "img/cogni_logo.1ad9bb28.png";